namespace Matrix.Data {
    export class SecurityInternalColumns {
        static columnsKey = 'Data.SecurityInternal';
    }
}
